import React, {useState, useEffect, useMemo} from "react";
import { debounce } from "lodash";

const SearchBox = ({
                       onSearch,
                       debounceDelay = 0,
                       placeholder = "Search...",
                       buttonLabel = "Search",
                       defaultValue = "",
                       triggerOn = "button", // "typing" | "button" | "both"
                       showButton = true,
                   }) => {
    const [input, setInput] = useState(defaultValue);

    const debouncedSearch = useMemo(
        () =>
            debounce((value) => {
                if (triggerOn === "typing" || triggerOn === "both") {
                    onSearch(value);
                }
            }, debounceDelay),
        [onSearch, triggerOn, debounceDelay]
    );

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const handleChange = (e) => {
        const value = e.target.value;
        setInput(value);
        debouncedSearch(value);
    };

    const handleButtonClick = () => {
        onSearch(input);
    };
    return (
        <div className="mb-3" style={{ display: "flex", gap: "40px", alignItems: "flex-end" }}>
            <div>
                <label className="text-label d-block mb-2">{placeholder}</label>
                <input
                    className="form-control"
                    style={{ width: "300px"}}
                    value={input}
                    onChange={handleChange}
                />
            </div>
            {showButton && (
                <div style={{ marginBottom: "3px" }}>
                    <button className="btn btn-secondary" onClick={handleButtonClick}>
                        {buttonLabel}
                    </button>
                </div>
            )}
        </div>
    );
};

export default SearchBox;
